const AddressMainTitle = () => (
    <h1 className="addressMainTitle  tablet-min:addressMainTitle__tablet__min tablet:addressMainTitle__tablet desktop:addressMainTitle__desktop desktop-min:addressMainTitle__desktop__min">
        Let’s add <span className="text-mint-green">Your Address.</span> Where should we ship your MedBox?
    </h1>
);

export default AddressMainTitle;